<template>
    <div>
        <div class="tw-flex tw-flex-col tw-gap-0 md:tw-gap-14 tw-text-xl md:tw-flex-row tw-px-0 xl:tw-px-6 tw-pt-10 tw-pb-0 xl:tw-pb-12">
            <div class="tw-flex tw-flex-col tw-w-full md:tw-w-1/6 tw-pt-0 md:tw-pt-4 tw-border-0 md:tw-border-t tw-border-dark-grey">
                <div class="h7 pb-2">Information</div>
            </div>

            <div class="tw-flex tw-flex-col xl:tw-flex-row tw-gap-0 lg:tw-gap-6 tw-w-full md:tw-w-5/6 tw-pt-0 md:tw-pt-4 tw-mb-0 xl:tw-mb-12 tw-justify-between tw-border-0 md:tw-border-t tw-border-dark-grey tw-text-2xl md:tw-text-4xl">
                <div class="tw-w-full xl:tw-w-3/6 tw-font-light tw-uppercase tw-pt-2 tw-pb-4 sm:tw-pb-6">
                    IATSE Local 667 & Local 671 <br>
                    229 Wallace Avenue <br>
                    Toronto ON M6H 1V5
                </div>
                <div class="tw-w-full xl:tw-w-3/6 tw-font-light tw-uppercase tw-pt-2 tw-pb-1 sm:tw-pb-6">
                    <a href="mailto:camera@iatse667.com">camera@iatse667.com</a><br>
                    <a href="tel:4163680072">416-368-0072</a> <br>
                    <p class="tw-pt-2 tw-text-lg tw-leading-tight">
                        Toll-Free: <a href="tel:18773681667">1-877-368-1667</a> <br>
                        Fax: 416-368-6932
                    </p>
                </div>
            </div>
        </div>
        <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-0 md:tw-gap-14 tw-px-0 xl:tw-px-6 tw-pt-6 tw-pb-2 lg:tw-pb-12 tw-text-xl">
            <div class="tw-flex tw-flex-col tw-w-full md:tw-w-1/6 tw-pt-4 tw-border-t tw-border-dark-grey">
                <div class="h7 pb-2">Staff Contact</div>
            </div>
            <v-expansion-panels
            flat
            class="tw-border-t tw-border-dark-grey rounded-0"
            >
                <v-expansion-panel v-for="contact in staff_contacts" :key="contact.id" class="tw-border-b tw-border-dark-grey" style="border-radius: 0px !important;">

                    <v-expansion-panel-header>
                        <div>
                            <span class="tw-text-xl">{{ contact.name }},</span>
                            <span v-show="!!contact.role">{{ contact.role }}</span>
                        </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <div class="tw-text-sm">
                            <span v-show="!!contact.email"><a :href="`mailto:${contact.email}`">{{ contact.email }}</a></span>
                            <span v-show="!!contact.email && !!contact.phone"> | </span>
                            <span v-show="!!contact.phone"><a :href="`tel:${contact.phone}`">{{ contact.phone }}</a></span>
                            <span v-show="!contact.email && !contact.phone">No extra information.</span>
                        </div>
                        <div class="tw-text-sm" v-show="!!contact.description">{{ contact.description }}</div>
                    </v-expansion-panel-content>

                </v-expansion-panel>
            </v-expansion-panels>
        </div>

        <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-0 md:tw-gap-14 tw-px-0 xl:tw-px-6 tw-pt-6 tw-pb-2 lg:tw-pb-12 tw-text-xl">
            <div class="tw-flex tw-flex-col tw-w-full md:tw-w-1/6 tw-pt-4 tw-border-t tw-border-dark-grey">
                <div class="h7 pb-2">Other Contact</div>
            </div>

            <div class="tw-flex tw-flex-col xl:tw-flex-row tw-w-full tw-gap-4 xl:tw-gap-14 tw-mb-6 xl:tw-mb-12">
                <div class="tw-flex tw-flex-col tw-w-full xl:tw-w-3/6 tw-pt-4 tw-border-t tw-border-dark-grey tw-font-light">
                    <div class="tw-pt-2 tw-pb-4 xl:tw-pb-6 tw-text-xl xl:tw-text-2xl">IATSE Local 667/669 Health & Welfare Benefits Administration</div>
                    <div class="tw-text-sm xl:tw-text-xl">
                        Leta Kennedy, Plan Administrator <br>
                        3823 Henning Drive, Suite 122 <br>
                        Burnaby BC  V5C 6P3 <br>
                        Phone:
                            <a :href="`tel:${$root.formatPhoneNumeric('778-329-4455')}`">778-329-4455</a><br>
                        Toll Free:
                            <a :href="`tel:${$root.formatPhoneNumeric('1-866-366-9667')}`">1-866-366-9667</a><br>
                        Email:
                            <a href="mailto:leta@iatse667-669healthplan.com">leta@iatse667-669healthplan.com</a>
                    </div>
                </div>
                <div class="tw-flex tw-flex-col tw-w-full xl:tw-w-3/6 tw-pt-4 tw-border-t tw-border-dark-grey tw-font-light">
                    <div class="tw-pt-2 tw-pb-4 xl:tw-pb-6 tw-text-xl xl:tw-text-2xl">Canadian Entertainment Industry Retirement Plan</div>
                    <div class="tw-text-sm xl:tw-text-xl">
                        Mary Miskic, 667 Plan Administrator <br>
                        CEIRP National Office <br>
                        22 St Joseph Street <br>
                        Toronto ON M4Y 1J9 <br>
                        Phone:
                            <a :href="`tel:${$root.formatPhoneNumeric('416-362-2665')}`">416-362-2665</a><br>
                        Toll Free:
                            <a :href="`tel:${$root.formatPhoneNumeric('1-833-657-4567')}`">1-833-657-4567</a><br>
                        <a href="www.ceirp.ca" target="_blank">www.ceirp.ca</a><br>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout'

    export default {
        name: "ContactUsIndex",
        layout: (h, page) => {
            return h(AppLayout, [
                page
            ])
        },
        props: {
            'staff_contacts': {
                type: Array,
                required: false,
                default: function () {
                    return undefined
                }
            },
        },
    }
</script>
<style scoped>
    ol li::marker {
       font-weight: 400;
    }
    li {
        font-weight: 300;
    }
</style>
